<div>
	<div class="d-flex">
		<div class="h3 m-2">
			<span *ngIf="!applicationIdSelected"> FocusPay Applications </span>
		</div>

		<div class="d-flex my-2 ms-auto">
			<p-button pRipple styleClass="p-button-raised p-button-success m-2" (click)="createDeal()">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'skull-crossbones']" size="lg" class="ms-1 me-2"></fa-icon>
						Register Deal
					</div>
				</ng-template>
			</p-button>
		</div>
	</div>

	<div class="card">
		<app-application-list-view
			(applicationIdSelectedEmitter)="applicationIdSelected = $event"
			(applicationIdStatusEmitter)="applicationIdStatus = $event"
		></app-application-list-view>
		<app-application-status-single
			*ngIf="applicationIdStatus"
			[applicationId]="applicationIdStatus"
			(applicationIdEmitter)="applicationIdStatus = undefined"
		></app-application-status-single>
	</div>
</div>
